import { apiRequest } from "../../api/apiRequest";
import { GET_PROFILE_DETAILS, GET_PROFILE_PERCENTAGE, POST_EDIT_PROFILE } from "../../utils/api";
import { EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE, PROFILE_DETAILS_FAILURE, PROFILE_DETAILS_SUCCESS, PROFILE_COMPLETION_SUCCESS, PROFILE_COMPLETION_FAILURE} from "./profile.actionTypes";

export const editProfile = (payLoad) => async (dispatch) => {
  const result = await apiRequest("put", POST_EDIT_PROFILE, payLoad);

  if (result.success) {
    dispatch({
      type: EDIT_PROFILE_SUCCESS,
      payload: { data: result.data },
    });
    return { success: true };
  } else {
    dispatch({
      type: EDIT_PROFILE_FAILURE,
      payload: { message: result.message },
    });
    return { success: false, message: result.message };
  }
};

export const profileDetails = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PROFILE_DETAILS);

  if (result.success) {
    dispatch({
      type: PROFILE_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: PROFILE_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const profileCompletionPercentage = () => async (dispatch) => {
  const result = await apiRequest("get", GET_PROFILE_PERCENTAGE);

  if (result.success) {
    dispatch({ type: PROFILE_COMPLETION_SUCCESS, payload: result.data });
    return result.data; // Return value to use in handleLogin
  } else {
    dispatch({ type: PROFILE_COMPLETION_FAILURE, payload: { message: result.message } });
    return null;
  }
};
